import { inject, Injectable } from '@angular/core';
import { type Observable } from 'rxjs';
import type { StateCountry } from '@td/dictionaries';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class StateCountryService {
  private readonly http = inject(HttpClient);

  load(): Observable<Array<StateCountry>> {
    return this.http.get<Array<StateCountry>>(`api/v1/dictionary/state-country`);
  }
}
